export default {
  init() {
    // JavaScript to be fired on the about us page
    document.querySelector('.gfield > [data-size="invisible"]').parentNode.style.display = 'none';
  },
  finalize() {

    //Radio Button Normalizer
    const radioButtons = document.querySelectorAll('.js-radio-button');

    const radioButtonHandler = (e) => {
      e.preventDefault();

      let thisRadioButton = e.target;

      radioButtons.forEach((radioButton) => {
        radioButton.classList.remove('radio-custom-selected');
      });

      thisRadioButton.classList.toggle('radio-custom-selected');
      document.querySelector(`input[data-radio-bind="${thisRadioButton.dataset.radioBind}"]`).click();
    }

    radioButtons.forEach((radioButton) => {
      radioButton.addEventListener('click', radioButtonHandler, false);
    });

    //File Button Normalizer
    const fileButtons = document.querySelectorAll('.js-file-button');

    const fileInputCallback = (e, realInput) => {
      e.preventDefault();

      let filename = realInput.value.split('\\').pop();

      // Bind the fake input's filename to the filename of the real input
      document.querySelector(`input[data-input-bind-faux="${realInput.dataset.inputBind}"]`).value = filename;
    }

    const fileButtonHandler = (e) => {
      e.preventDefault();

      let thisFileButton = e.target;
      let realInput = document.querySelector(`input[data-input-bind="${thisFileButton.dataset.inputBind}"]`);

      realInput.addEventListener('change', (e) => {
        fileInputCallback(e, realInput)
      }, false);
      realInput.click();
    }

    fileButtons.forEach((fileButton) => {
      fileButton.addEventListener('click', fileButtonHandler, false);
    });

    // Advisor Resources SVG
    const importantLinks = document.querySelector('#Group_185');
    const softwareDownload = document.querySelector('#Group_184');
    const advisorPortal = document.querySelector('#Group_182');

    const importantLinksLink = document.querySelector('.js-important-links').href;
    const softwareDownloadLink = document.querySelector('.js-software-download').href;
    const advisorPortalLink = document.querySelector('.js-advisor-portal').href;

    [importantLinks, softwareDownload, advisorPortal].forEach((svgArea) => {
      svgArea.style.cursor = 'pointer';
    });

    const advisorResourcesHandler = (e, url) => {
      e.preventDefault();

      window.open(url, '_blank').focus();
    }

    importantLinks.addEventListener('click', (e) => { advisorResourcesHandler(e, importantLinksLink) });
    softwareDownload.addEventListener('click', (e) => { advisorResourcesHandler(e, softwareDownloadLink) });
    advisorPortal.addEventListener('click', (e) => { advisorResourcesHandler(e, advisorPortalLink) });

    if (!window.atfVars.featureFlags.events) return;
      //Event Calendar Component
      const removeChildNodes = (node) => {
        while (node.firstChild) {
          node.removeChild(node.lastChild);
        }
      }

      const eventCalendarFull = document.querySelector('.events-calendar');
      const calendarEventsArea = document.querySelector('.events-calendar-events');
      const eventControlDate = document.querySelector('.events-control-date');
      const emptyMessage = document.querySelector('.empty-message');
      const emptyMessageDate = document.querySelector('.empty-message-date');

      const eventsLButton = document.querySelector('.events-l-button');
      const eventsRButton = document.querySelector('.events-r-button');
      let currentCalendarSelection = 0;

      let calendarEvents = [
        {
          'month': 'October 2020',
          'data': [
            {
              'date': 'Tues 17 Oct',
              'title': 'Investment Tax Seminar',
              'time': '10:30AM - 12:30PM',
              'address': '123 Seminar Address St.',
            },
            {
              'date': 'Thurs 22 Oct',
              'title': 'Dental Insurance Seminar',
              'time': '10:30AM - 12:30PM',
              'address': '123 Seminar Address St.',
            },
            {
              'date': 'Fri 29 Oct',
              'title': 'International Student Visas - FAQ Session',
              'time': '10:30AM - 12:30PM',
              'address': '123 Seminar Address St.',
            },
          ],
        },
        {
          'month': 'November 2020',
          'data': [
            {
              'date': 'Tues 17 Nov',
              'title': 'Investment Tax Seminar',
              'time': '10:30AM - 12:30PM',
              'address': '123 Seminar Address St.',
            },
            {
              'date': 'Thurs 22 Nov',
              'title': 'Dental Insurance Seminar',
              'time': '10:30AM - 12:30PM',
              'address': '123 Seminar Address St.',
            },
          ],
        },
        {
          'month': 'December 2020',
          'data': [],
        },
      ];

      const createCalendarEntry = (calendarEntryData) => {
        let eventsCalendarEvent = document.createElement('div');
        eventsCalendarEvent.classList.add('events-calendar-event');

        let eventsCalendarTitle = document.createElement('div');
        eventsCalendarTitle.classList.add('events-calendar-title');

        let dataInfoArray = calendarEntryData.date.split(' ');

        let p0 = document.createElement('p');
        p0.textContent = dataInfoArray[0];
        let span0 = document.createElement('span');
        span0.textContent = dataInfoArray[1];
        let p1 = document.createElement('p');
        p1.textContent = dataInfoArray[2];

        eventsCalendarTitle.appendChild(p0);
        eventsCalendarTitle.appendChild(span0);
        eventsCalendarTitle.appendChild(p1);

        eventsCalendarEvent.appendChild(eventsCalendarTitle);

        let eventsCalendarBody = document.createElement('div');
        eventsCalendarBody.classList.add('events-calendar-body');

        let h30 = document.createElement('h3');
        h30.textContent = calendarEntryData.title;
        let p2 = document.createElement('p');
        p2.textContent = calendarEntryData.time;
        let p3 = document.createElement('p');
        p3.textContent = calendarEntryData.address;

        eventsCalendarBody.appendChild(h30);
        eventsCalendarBody.appendChild(p2);
        eventsCalendarBody.appendChild(p3);

        eventsCalendarEvent.appendChild(eventsCalendarBody);

        return eventsCalendarEvent;
      }

      const setCalendarContents = (calendarData) => {
        let events = [];

        if (calendarData) {
          calendarData.data.forEach((calendarEvent) => {
            events.push(createCalendarEntry(calendarEvent));
          });

          removeChildNodes(eventControlDate);
          removeChildNodes(calendarEventsArea);

          let p0 = document.createElement('p');
          p0.textContent = calendarData.month.replace(' ', ', ');

          eventControlDate.append(p0);

          events.forEach((event) => {
            calendarEventsArea.append(event);
          });
        } else {
          removeChildNodes(eventControlDate);
          removeChildNodes(calendarEventsArea);

          let p0 = document.createElement('p');
          p0.textContent = emptyMessageDate.innerHTML;

          eventControlDate.append(p0);

          let p1 = document.createElement('p');
          p1.classList.add('no-events-text');
          p1.textContent = emptyMessage.innerHTML;

          calendarEventsArea.append(p1);
        }
      }

      const handleCalendarChange = (e, direction) => {
        e.preventDefault();

        if (direction === 'left') {
          currentCalendarSelection--;
        }

        if (direction === 'right') {
          currentCalendarSelection++;
        }

        if (currentCalendarSelection < 0) {
          currentCalendarSelection = calendarEvents.length - 1;
        }

        setCalendarContents(calendarEvents[currentCalendarSelection % calendarEvents.length]);
      }

      const initCalendar = () => {
        eventCalendarFull.classList.remove('events-calendar-disabled');

        setCalendarContents(calendarEvents[0]);
      }

    eventsLButton.addEventListener('click', (e) => { handleCalendarChange(e, 'left') });
    eventsRButton.addEventListener('click', (e) => { handleCalendarChange(e, 'right') });

    fetch('/wp-json/atf/v1/events').then(
      (res) => {
        return res.json();
      }
    ).then((data) => {
      // console.log(data);
      calendarEvents = data;
      initCalendar();
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/become-an-agent.js